import * as React from 'react';
import { observer, inject } from 'mobx-react';

// UITk
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkBadgeLoyalty, UitkBadgeProgram } from 'uitk-react-badge';

// Support Types
import { HotelInventoryCardProps } from './types.d';
type OfferProps = Pick<HotelInventoryCardProps, 'offer'>;

// Helper
import { checkValue } from 'src/components/common/helper';

const defaultUndefinedMark = 'lastminute';
const MarkBrandMap = {
  expedia: 'mod_exp',
  lastminute: undefined,
  orbitz: 'mod_orb',
  travelocity: 'mod_tvly',
  wotif: 'mod_wotif',
  cheaptickets: 'mod_ctx',
  ebookers: 'mod_ebook',
};

const MarkIcon = inject('context')(
  observer((props) => {
    const { context } = props;
    const markName = MarkBrandMap[context?.site?.brand ?? defaultUndefinedMark];
    if (markName) {
      return <UitkMark name={markName} size={UitkMarkSize.SMALL} />;
    }
    return <UitkIcon name="mod" size={UitkIconSize.SMALL} />;
  })
);

export const ImageBadges: React.FC<OfferProps> = ({ offer }: any) => {
  const hotelOffer = offer;

  if (hotelOffer?.vipMessage && hotelOffer?.mod?.modTagText) {
    return (
      <>
        <UitkLayoutFlexItem>
          <UitkBadgeProgram theme='member'>
            <MarkIcon />
          </UitkBadgeProgram>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <UitkBadgeLoyalty theme='vip' text={hotelOffer.vipMessage} />
        </UitkLayoutFlexItem>
      </>
    );
  }

  if (hotelOffer?.vipMessage) {
    return <UitkBadgeLoyalty theme='vip' text={hotelOffer.vipMessage} />;
  }

  if (hotelOffer?.mod?.modTagText) {
    return (
      <UitkLayoutFlexItem>
        <UitkBadgeProgram theme='member' text={hotelOffer.mod.modTagText}>
          <MarkIcon />
        </UitkBadgeProgram>
      </UitkLayoutFlexItem>
    );
  }

  return null;
};

export interface ImageBadgesForPropertySearchProps {
  message: string;
}

export const ImageBadgesForPropertySearch: React.FC<ImageBadgesForPropertySearchProps> = (props) => {
  const { message } = props;
  if (checkValue(message)) {
    return <UitkBadgeLoyalty theme='vip' text={message} />;
  }

  return null;
};
